import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { gql } from "types";

export const RETRY_WORKFLOW_CONFIG_FETCH = gql(/* GraphQL */ `
  mutation RetryWorkflowConfigFetch($runId: String!) {
    retryWorkflowConfigFetch(runId: $runId) {
      status
      error
      commitSha
    }
  }
`);

export const useRetryConfigFetch = () => {
  const [retryWorkflowConfigFetch, { loading }] = useMutation(
    RETRY_WORKFLOW_CONFIG_FETCH,
  );

  const retryConfigFetch = useCallback(
    async (runId: string) => {
      const { data } = await retryWorkflowConfigFetch({
        variables: { runId },
      });
      return data?.retryWorkflowConfigFetch ?? null;
    },
    [retryWorkflowConfigFetch],
  );

  return { retryConfigFetch, loading };
};
